export default __webpack_public_path__ + "static/media/discord.b1c5d87a.svg";